module.exports = __webpack_public_path__ + "data/skeeballPlay.dd629995580b254df2c1d7e0068124d1.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=data/[name].[hash].json!./app/assets/image/MN/skeeballPlay.json
// module id = 351
// module chunks = 0